import { createFileRoute } from "@tanstack/react-router";
import { UsageScreen } from "./-usage/UsageScreen";

export const Route = createFileRoute("/admin/usage")({
  staticData: { title: "Usage" },
  component: UsageScreen,
});
